import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    // Populate the component parts with theme styles
    return {
        input: {
            boxSizing: 'border-box',
            minHeight: '32px',
            paddingTop: '3px',
            paddingBottom: '3px',
            paddingLeft: '5px',
            paddingRight: '5px',
            ...theme.fonts.default,
        },

        hoover: {
            boxSizing: 'border-box',
            minHeight: '32px',
            paddingTop: '3px',
            paddingBottom: '3px',
            paddingLeft: '5px',
            paddingRight: '5px',
            backgroundColor: theme.detailAttributeBackgroundColor || theme.inputBackgroundColor,
        },

        underline: {
            borderColor: theme.textInputUnderlineColor,
        },

        underlineFocus: {
            borderColor: theme.textInputUnderlineColor,
        },

        underlineHover: {
            borderColor: theme.textInputUnderlineColor,
        },
    };
};

export default getTheme;
